/**
 * iter213 — Standalone Vehicle History page.
 * Mounts the VehicleHistoryPanel in "page" mode so FOH can bookmark
 * or deep-link to a reg (e.g. `/app/foh/vehicles/D8ANS`). Also
 * supports a lookup input to swap between vehicles without leaving
 * the page.
 */
import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Search, ArrowLeft } from "lucide-react";
import { VehicleHistoryPanel } from "@/components/intake/VehicleHistoryPanel";

export default function VehicleHistoryPage() {
  const { reg: regParam } = useParams();
  const navigate = useNavigate();
  const [regInput, setRegInput] = useState(regParam || "");

  const submit = (e) => {
    e.preventDefault();
    const compact = (regInput || "").toUpperCase().replace(/[^A-Z0-9]/g, "");
    if (compact) navigate(`/app/foh/vehicles/${compact}`, { replace: false });
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <div className="border-b border-slate-200 bg-white px-4 py-3 flex items-center gap-3">
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="p-1.5 rounded hover:bg-slate-100 text-slate-500"
          title="Back"
          data-testid="vh-page-back"
        >
          <ArrowLeft className="w-4 h-4" />
        </button>
        <form onSubmit={submit} className="flex-1 max-w-md relative">
          <Search className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
          <input
            type="text"
            value={regInput}
            onChange={(e) => setRegInput(e.target.value.toUpperCase())}
            placeholder="Registration (e.g. AB12 CDE)"
            className="w-full border border-slate-300 rounded-lg pl-9 pr-3 py-2 text-sm font-mono focus:ring-2 focus:ring-teal-300 focus:border-teal-500 outline-none"
            data-testid="vh-page-reg-input"
            autoComplete="off"
          />
        </form>
      </div>

      <div className="max-w-3xl mx-auto">
        {regParam ? (
          <VehicleHistoryPanel reg={regParam} mode="page" isOpen />
        ) : (
          <div className="p-10 text-center text-slate-500 text-sm" data-testid="vh-page-empty">
            Enter a registration above to see its full history.
          </div>
        )}
      </div>
    </div>
  );
}
